import { instance, setHeader } from "./auth-api";

//INFO: TGM - trade group manager

export const tradegroupAPI = {
  getTGsList: async () => {
    return await instance.get("agency/list", {
      headers: setHeader(),
    });
  },
  getAccountsList: async (withParams) => {
    let params = {};
    if (withParams) {
      withParams.forEach((p) => (params[p] = 1));
    }
    return await instance.get(`application/extended-list`, {
      headers: setHeader(),
      params,
    });
  },
  createTradingPackage: async (body) => {
    const response = await instance.post("application", body, {
      headers: setHeader(),
    });
    return response;
  },
  setApplicationStatus: async (body) => {
    const response = await instance.put("application/status", body, {
      headers: setHeader(),
    });
    return response;
  },
  getTGBalance: async (agencyID) => {
    return await instance.get(`agency/${agencyID}/balance`, {
      headers: setHeader(),
    });
  },
  getAccountsRequests: async (params) => {
    return await instance.get("request/list", {
      headers: setHeader(),
      params,
    });
  },
  getRSMetadata: async (applicationID) => {
    let url = "request/risk-setting-metadata?needDefault=1";
    if (applicationID) {
      url += `&applicationID=${encodeURIComponent(applicationID)}`;
    }
    const response = await instance.get(url, {
      headers: setHeader(),
    });
    return response;
  },
  createDataRequest: async (accID, body) => {
    body = { ...body, applicationID: accID };
    const response = await instance.post("request", body, {
      headers: setHeader(),
    });
    return response;
  },
  updateRequest: async (requestID, body = {}) => {
    const response = await instance.put(
      `request/${requestID}`,
      body,
      { headers: setHeader() }
    );
    return response;
  },
  setRequestStatusAction: async (requestID, body = {}, action = "") => {
    const response = await instance.put(
      `request/${requestID}/${action}`,
      body,
      { headers: setHeader() }
    );
    return response;
  },
  getAgencyList: async () => {
    return await instance.get("agency/list", {
      headers: setHeader(),
    });
  },
  getGeneratedTraderID: async (body) => {
    return await instance.post("application/generate-trader-id", body, {
      headers: setHeader(),
    });
  },
  upgradeSimulator: async (email) => {
    const response = await instance.post("registration/v2/upgrade-to-live-by-email", { email }, {
      headers: setHeader(),
    });
    return response;
  },
};
